module.exports = __webpack_public_path__ + "media/recipes/115-ccdb0f17.png";